import React from 'react';
import Head from 'next/head';
import { NotFoundError } from '@/components/ErrorComponents';
import { NextPageContext } from 'next';

interface errorProps {
  error: Error;
  reset: () => void;
  statusCode: number;
  message: string;
}

export default function GlobalError(props: errorProps) {
  const { statusCode, message } = props;
  return (
    <>
      <Head>
        <title>Eureka Forbes</title>
        <meta name="description" content="Eureka forbes" />
      </Head>
      <NotFoundError statusCode={statusCode} message={message} />
    </>
  );
}

GlobalError.getInitialProps = ({ req, res, err }: NextPageContext) => {
  console.log('Error request url: ', req?.url, req?.method);
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  const message = res ? res.statusMessage : err ? err.message : 'Something went wrong';
  return { statusCode, message };
};
